var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Din Nexa Bridge uppdateras automatiskt varje gång en ny mjukvara finns tillgänglig så du kommer inte att behöva göra något. Just nu körs version "),_c('strong',[_vm._v(_vm._s(_vm.$root.data.info.version))]),_vm._v(" på din Bridge.\n  \n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb0ae06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/installningar_uppdateringar.vue
// module id = null
// module chunks = 